export default __webpack_public_path__ + "static/sps-version-2024-new-5f1e426f5052a9c38885daae51fc4502.png";